import { Component, EventEmitter, Output } from '@angular/core';
import { COMPONENT_NAME, EVENT_TYPE } from '@app/constants/message.constants';
import { MessageAction } from '@app/models/message-action.model';
import { MessageComponent } from '@app/models/message-base.component';

@Component({
  selector: 'app-send-to-hr',
  templateUrl: './send-to-hr.component.html',
  styleUrls: ['./send-to-hr.component.scss']
})
export class SendToHRComponent extends MessageComponent {
  @Output() onMessageAction = new EventEmitter<MessageAction>();
  override type = COMPONENT_NAME.SEND_HR;

  onSendToHR() {
    this.enabledButtons = false;
    this.onMessageAction.emit({ type: EVENT_TYPE.SHOULD_SEND_HR, value: true });
  }

  onRefuseToSendToHR() {
    this.enabledButtons = false;

    this.onMessageAction.emit({ type: EVENT_TYPE.SHOULD_SEND_HR, value: false });
  }
}
